export default "__VITE_ASSET__DtzgxmvL__"